import { render, staticRenderFns } from "./multi-checkbox.vue?vue&type=template&id=2f1496e0&scoped=true&lang=pug&"
import script from "./multi-checkbox.vue?vue&type=script&lang=js&"
export * from "./multi-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./multi-checkbox.vue?vue&type=style&index=0&id=2f1496e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1496e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsMultiCheckboxInput: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/multi-checkbox-input.vue').default})
